import { boardCategories } from "@/mocks/home";

export default function TopicsSection() {
  return (
    <section id="topics" className="relative bg-background-100/70 py-16 md:py-20">
      <div className="container-site">
        <div className="max-w-2xl">
          <span className="text-xs font-bold uppercase tracking-widest text-accent-700">
            主题板块
          </span>
          <h2 className="mt-2 text-2xl font-black text-foreground-950 md:text-4xl">
            挑个瓜田 · 找你的同好
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            明星吃瓜、追剧雷达、树洞倾诉……按兴趣进板块，评论区、群聊、树洞随你逛，对暗号蹲后续都不耽误。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {boardCategories.map((b) => (
            <a
              key={b.id}
              href="#treehole"
              className="group flex flex-col rounded-xl border border-background-200/70 bg-background-50 p-5 transition hover:-translate-y-1 hover:border-accent-300 hover:shadow-soft"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-accent-100 text-accent-700 transition group-hover:bg-accent-500 group-hover:text-background-50">
                <i className={`${b.icon} text-2xl`}></i>
              </span>
              <div className="mt-4 flex items-center justify-between">
                <h3 className="text-base font-bold text-foreground-950">{b.name}</h3>
                <span className="text-[11px] text-foreground-600">{b.count}</span>
              </div>
              <p className="mt-1 text-xs leading-relaxed text-foreground-600">{b.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-xs font-semibold text-primary-600 opacity-0 transition group-hover:opacity-100">
                进板块逛逛 <i className="ri-arrow-right-line"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}